import { api } from '@/lib/api-client';

export interface HolidayRow {
  id: string;
  date: string;
  label: string;
  recurringAnnual: boolean;
  createdAt: string;
  updatedAt: string;
  updatedBy: string;
}

export interface HolidayPostBody {
  date: string;
  label: string;
  recurringAnnual: boolean;
}

export function list(): Promise<HolidayRow[]> {
  return api.get<HolidayRow[]>('/admin/holidays');
}

export function create(body: HolidayPostBody): Promise<HolidayRow> {
  return api.post<HolidayRow>('/admin/holidays', body);
}

export function remove(id: string): Promise<void> {
  return api.delete<void>(`/admin/holidays/${id}`);
}
